import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Polygon, useMap } from "react-leaflet";
import { useEffect } from "react";

// Fix Leaflet default icon issue
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

interface ProjectMapProps {
    latitude: number;
    longitude: number;
    boundary: { lat: number; lng: number }[] | null;
    zoom?: number;
    className?: string;
}

// Component to update map center when props change
function ChangeView({ center, zoom }: { center: [number, number]; zoom: number }) {
    const map = useMap();
    useEffect(() => {
        map.setView(center, zoom);
    }, [center, zoom, map]);
    return null;
}

export const ProjectMap = ({ latitude, longitude, boundary, zoom = 13, className = "h-96 w-full rounded-lg" }: ProjectMapProps) => {
    if (!latitude || !longitude) return null;

    const center: [number, number] = [latitude, longitude];

    return (
        <MapContainer center={center} zoom={zoom} className={className} scrollWheelZoom={false}>
            <ChangeView center={center} zoom={zoom} />
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={center} />
            {boundary && boundary.length > 0 && (
                <Polygon
                    positions={boundary.map(p => [p.lat, p.lng] as [number, number])}
                    pathOptions={{ color: "blue" }}
                />
            )}
        </MapContainer>
    );
};
